module.exports = __webpack_public_path__ + "img/MELA_CD4Tconv.cc373846.png";